// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_sP049","logo":"logo_sP049","megaMenu":"megaMenu_sP049","modalButtonWrap":"modalButtonWrap_sP049","modalButton":"modalButton_sP049"};